import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from './error.component';
import { IconModule } from '@pc-ui/icon';

@NgModule({
  declarations: [ErrorComponent],
  imports: [CommonModule, IconModule],
  exports: [ErrorComponent],
})
export class ErrorModule {}
